import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    placeContent: "center",
    position: "relative",
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    padding: `${theme.spacing.space12}px ${theme.spacing.space16}px`,
    overflow: "hidden",
    border: `none`,
    borderRadius: 100,
    textAlign: "-webkit-center",
    fontSize: 14,
    fontWeight: theme.fontWeight.semiBold,
    fontFamily: "Poppins",
    boxSizing: "border-box",
    width: "fit-content",
    lineHeight: "20px",
    gap: theme.spacing.space8,
    minWidth: "fit-content",
    "& > span": {
      "&.ripple": {
        position: "absolute",
        borderRadius: "50%",
        transform: "scale(0)",
        animation: "$ripple 600ms linear",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
      },
    },
    "&.start": {
      flexDirection: "row-reverse",
    },
    "&.only-icon": {
      borderRadius: theme.radius.small,
      padding: theme.spacing.space8,
    },
    "&.fullWidth": {
      width: "100%",
    },
    "&.small": {
      padding: `${theme.spacing.space4}px ${theme.spacing.space8}px`,
      fontSize: 12,
      fontWeight: theme.fontWeight.semiBold,
      gap: theme.spacing.space4,
    },
    "&.primary": {
      background: theme.colors.primary,
      color: theme.colors.text1,
    },
    "&.highlight": {
      background:
        "linear-gradient(325deg, #DE9239 -24.57%, #FDD74E 49.37%, #DE9239 108.65%)",
      color: theme.colors.text0,
    },
    "&.outlined": {
      background: "transparent",
      border: `1.5px solid ${theme.colors.border3}`,
      color: theme.colors.text1,
    },
    "&.borderless": {
      background: "transparent",
      color: theme.colors.text1,
    },
    "&.disabled": {
      background: theme.colors.background6,
      color: theme.colors.text4,
      border: "none",
      pointerEvents: "none",
    },
  },

  overlay: {
    background: "",
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
  },
  "@keyframes ripple": {
    to: {
      transform: "scale(3)",
      opacity: 0,
    },
  },
}));
